export default "__VITE_ASSET__C9uAxx1q__"